// extracted by mini-css-extract-plugin
export var sectionMain = "partnersLogos-module--sectionMain--Y5bzz";
export var dark = "partnersLogos-module--dark--4FAmT";
export var coloredLogos = "partnersLogos-module--coloredLogos--E0wki";
export var logos = "partnersLogos-module--logos--NEm5Z";
export var fadeIn = "partnersLogos-module--fadeIn--lIWug";
export var slideIn = "partnersLogos-module--slideIn--kKgyE";